export default "__VITE_ASSET__3cc7a3fd__"